export default function makeDefaultVerifiedProxyCount() {
  const isDev = process.env.NEXT_PUBLIC_ENVIRONMENT === "dev";
  return isDev ? 10 : 5000;
}
